import { MissingControllerProps } from '../../utils/errors.js';
import { buildUrlManager, } from './headless-url-manager.js';
export * from './headless-url-manager.js';
/**
 * @internal
 * @group Definers
 *
 */
export const defineUrlManager = () => ({
    buildWithProps: (engine, props) => {
        if (props === undefined) {
            throw new MissingControllerProps('UrlManager');
        }
        return buildUrlManager(engine, { initialState: props.initialState });
    },
});
